module.exports = __webpack_public_path__ + "static/media/social-steam.b75c1c4a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/auth/social-steam.svg
// module id = 221
// module chunks = 0